import { render, staticRenderFns } from "./KnowledgeBaseSync.vue?vue&type=template&id=2d16f00c&scoped=true&"
import script from "./KnowledgeBaseSync.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseSync.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeBaseSync.vue?vue&type=style&index=0&id=2d16f00c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d16f00c",
  null
  
)

export default component.exports